import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { WarehouseReleaseProductBrandResponse } from './warehouse-release-product-brand.response';

@jsonObject
export class WarehouseReleaseProductResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly sku!: string;

  @jsonMember(WarehouseReleaseProductBrandResponse)
  public readonly brand!: WarehouseReleaseProductBrandResponse;
}
